<template>
    <vs-popup id="salary-chart-popup" title="Salary Chart" :active.sync="popupSalaryChart.isOpen">
        <div class="position-relative salary-chart-dropdown-group">
            <div class="flex align-center" style="position: absolute; top: 50%; left: 10px; transform: translateY(-50%);">
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1024 1024" style="width: 15px; fill: #626262; margin-right: 10px;">
                    <path d="M940.218182 107.054545h-209.454546V46.545455h-65.163636v60.50909H363.054545V46.545455H297.890909v60.50909H83.781818c-18.618182 0-32.581818 13.963636-32.581818 32.581819v805.236363c0 18.618182 13.963636 32.581818 32.581818 32.581818h861.090909c18.618182 0 32.581818-13.963636 32.581818-32.581818V139.636364c-4.654545-18.618182-18.618182-32.581818-37.236363-32.581819zM297.890909 172.218182V232.727273h65.163636V172.218182h307.2V232.727273h65.163637V172.218182h176.872727v204.8H116.363636V172.218182h181.527273zM116.363636 912.290909V442.181818h795.927273v470.109091H116.363636z"></path>
                </svg>
                {{start_date}} - {{end_date}}
                <feather-icon icon="ChevronDownIcon" svgClasses="w-5 stroke-current ml-2" />
            </div>
            <div class="datepicker-container h-full">
                <date-picker class="salary-chart-datepicker" range-separator="  to  " v-model="filter_days" type="date" :editable="false" :open.sync="isOpenCalendar" range
                    @change="getCustomDaysFilter"></date-picker>
            </div>
            <vs-dropdown vs-trigger-click class="cursor-pointer salary-chart-dropdown">
                <vs-dropdown-menu class="salary-chart-dropdown-menu">
                    <vs-dropdown-item v-for="(item, index) in filterOptions" :key="index" @click="selectItem(item)">
                        <div class="flex justify-between" :class="{'text-primary': filter.id == item.id}">
                            {{item.title}}
                            <feather-icon icon="CheckIcon" svgClasses="h-3 w-3 ml-2" v-if="filter.id == item.id" />
                        </div>
                    </vs-dropdown-item>
                    <!-- <li class="vs-component vs-dropdown--item" style="" @click.stop="openCalendar">
                        <a class="vs-dropdown--item-link">Custom Range</a>
                    </li> -->

                    <!-- <div class="menu-container" v-if="isOpenCalendar">
                        <p class="mr-4">fsdfsdf - sdfsdfsdf</p>
                        <vs-button color="danger" type="border" class="text-sm mr-4 px-4 py-2 menu-container-btn cancel-btn">Cancel</vs-button>
                        <vs-button class="text-sm mr-4 px-4 py-2 menu-container-btn apply-btn">Apply</vs-button>
                    </div> -->

                </vs-dropdown-menu>
            </vs-dropdown>
        </div>

        <div class="w-full mt-base text-center">
            <!-- SALARY CHART O DAY NHE -->
            <line-chart :chartInfo="chartInfo" :isFromSalaryChart="true" class="w-full mt-12" :key="chart_key"></line-chart>
        </div>
    </vs-popup>
</template>

<script>
import DatePicker from 'vue2-datepicker';
import moment from 'moment';
export default {
    name: 'salary-chart-popup',
    components: { DatePicker },
    props: {
        popupSalaryChart: {
            type: Object,
            required: true
        }
    },
    data() {
        let filterOptions = [];
        let filter = {
            id: 1,
            title: 'Today',
            type: 'today',
            start_date: moment().format('MMMM DD, yyyy'),
            end_date: moment().format('MMMM DD, yyyy')
        };
        let start_date = filter.start_date;
        let end_date = filter.end_date;
        filterOptions = this.getfilterOptions();
        // console.log(filterOptions);
        return {
            filter_days: [],
            isOpenCalendar: false,
            filterOptions,
            filter,
            start_date,
            end_date,
            isOpenLoading: false,
            chartInfo: {},
            chart_key: 0
        }
    },
    watch: {
        popupSalaryChart: {
            immediate: true,
            deep: true,
            handler() {
                if(this.popupSalaryChart.isOpen) {
                    document.body.classList.add('overflow-hidden');
                    this.chart_key++;
                } else {
                    document.body.classList.remove('overflow-hidden');
                }
            }
        },
        filter: {
            immediate: true,
            deep: true,
            handler() {
                this.start_date = this.filter.start_date;
                this.end_date = this.filter.end_date;
                this.getSalaryChart();
            }
        }
    },
    methods: {
        openLoadingInDiv(){
            this.$vs.loading({
                container: '#app',
                scale: 0.8
            })
            if(this.loadTime){
                clearTimeout(this.loadTime);
                this.loadTime = null;
            }
            this.isOpenLoading = true;
            this.loadTime = setTimeout( ()=> {
                if(this.isOpenLoading) {
                this.closeLoading();
                this.$vs.dialog({
                    color: 'danger',
                    title: 'Notification',
                    text: 'Get Salary Chart Data Failed',
                    acceptText: 'OK'
                })
                }
            }, 10000);

        },
        closeLoading() {
            this.$vs.loading.close('#app > .con-vs-loading');
            this.isOpenLoading = false;
        },
        getfilterOptions() {
            let filterOptions = [];
            filterOptions.push({
                id: filterOptions.length + 1,
                title: 'Today',
                type: 'today',
                start_date: moment().format('MMMM DD, yyyy'),
                end_date: moment().format('MMMM DD, yyyy')
            });
            filterOptions.push({
                id: filterOptions.length + 1,
                title: 'Yesterday',
                type: 'yesterday',
                start_date: moment().subtract(1, 'days').format('MMMM DD, yyyy'),
                end_date: moment().subtract(1, 'days').format('MMMM DD, yyyy')
            });
            filterOptions.push({
                id: filterOptions.length + 1,
                title: 'Last 7 Days',
                type: 'last_7_days',
                start_date: moment().subtract(6, 'days').format('MMMM DD, yyyy'),
                end_date: moment().format('MMMM DD, yyyy')
            });
            filterOptions.push({
                id: filterOptions.length + 1,
                title: 'Last 30 Days',
                type: 'last_30_days',
                start_date: moment().subtract(29, 'days').format('MMMM DD, yyyy'),
                end_date: moment().format('MMMM DD, yyyy')
            });
            filterOptions.push({
                id: filterOptions.length + 1,
                title: 'This Month',
                type: 'this_month',
                start_date: moment().startOf('month').format('MMMM DD, yyyy'),
                end_date: moment().endOf('month').format('MMMM DD, yyyy')
            });
            filterOptions.push({
                id: filterOptions.length + 1,
                title: 'Last Month',
                type: 'last_month',
                start_date: moment().subtract(1, 'months').startOf('month').format('MMMM DD, yyyy'),
                end_date: moment().subtract(1, 'months').endOf('month').format('MMMM DD, yyyy')
            });
            filterOptions.push({
                id: filterOptions.length + 1,
                title: 'Custom Range',
                type: 'custom_range',
                start_date: null,
                end_date: null
            });

            if(this.filter && this.filter.id > 0) {
                this.filter = filterOptions[this.filter.id - 1];
            }

            return filterOptions;
        },
        getCustomDaysFilter() {
            if(this.filter_days.length != 0) {
                if(this.filterOptions && this.filterOptions.length > 0) {
                    this.filterOptions[this.filterOptions.length - 1].start_date = moment(this.filter_days[0]).format('MMMM DD, yyyy');
                    this.filterOptions[this.filterOptions.length - 1].end_date = moment(this.filter_days[1]).format('MMMM DD, yyyy');
                    this.filter = this.filterOptions[this.filterOptions.length - 1];
                }
            }
        },
        selectItem(item) {
            if(item.type == 'custom_range') {
                this.isOpenCalendar = true;
            } else {
                this.filter = item;
                this.filter_days = [];
            }
        },
        getSalaryChart() {
            let obj = {
                start_date: moment(this.filter.start_date).format('YYYY/MM/DD'),
                end_date: moment(this.filter.end_date).format('YYYY/MM/DD')
            }
            if(!this.isOpenLoading) {
                this.openLoadingInDiv();
            }
            this.$store.dispatch('goPos/GET_SALARY_CHART', obj).then((res) => {
                this.initData(res);
                this.chart_key++;
                this.closeLoading();
            })
        },
        initData(data) {
            let datasets = [];
            let labels = [];
            let dataset_item = {
                backgroundColor: "rgb(30, 79, 160)",
                data: [],
                label: "Salary"
            }
            if(data && data.employee_list) {
                for(let key in data.employee_list) {
                    labels.push(data.employee_list[key].name);
                    dataset_item.data.push(data.employee_list[key].total_salary);
                }
                datasets.push(dataset_item);
                this.chartInfo = {
                    datasets: datasets,
                    labels: labels
                }
            }
            // if(data && data.employee_list && data.employee_list.length > 0) {
            //     for(let i = 0; i < data.employee_list.length; i++) {
            //         labels.push(data.employee_list[i].name);
            //         dataset_item.data.push(data.employee_list[i].total_salary);
            //     }
            //     datasets.push(dataset_item);
            //     this.chartInfo = {
            //         datasets: datasets,
            //         labels: labels
            //     }
            // }
        }
    },
    created() {
        this.getSalaryChart();
    }
}
</script>